
import Vue from 'vue'

function transformer({ conversation, ai_response: response, userInput }) {
  return {
    response: response || userInput,
    conversation
  }
}

export default ({ text, conversation }) =>
  Vue.$http.post('avi_chat/send_message/', { user_input: text.trim(), conversation })
    .then(response => transformer(response.data))




// WEBPACK FOOTER //
// ./src/services/chat/sendMessage.js